var AppIcon = Object.freeze({
  isSupported: function isSupported() {
    return Promise.resolve(false);
  },
  getCurrentName: function getCurrentName() {
    return Promise.resolve("");
  },
  setIcon: function setIcon(_name) {
    return Promise.resolve();
  }
});
export {
  AppIcon
};
//# sourceMappingURL=unavailable.js.map
